import React from 'react';

const Footer = () => (
  <footer className="bg-gray-100 p-10 text-center">
    <a
      href="https://www.linkedin.com/company/reverra/about/"
      target="_blank"
      rel="noopener noreferrer"
      className="flex justify-center items-center space-x-2"
    >
      <img src="/linkedin_logo.png" alt="LinkedIn" className="mx-auto h-6 w-6" />
    </a>
  </footer>
);

export default Footer;